module.exports = __webpack_public_path__ + "static/media/tennis.a16f826d.webp";